import { useState } from 'react';
import { CourseStatusClient, CourseStatusDTO } from '../services/apiClient';
import { API_BASE_URL } from '../config/config';
import axiosInstance from '../services/axiosInstance';

export const useCourseStatusApi = () => {
    const apiClient = new CourseStatusClient(API_BASE_URL, axiosInstance);

    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState<string | null>(null);

    const create = async (data: CourseStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.createCourseStatus(data);
        } catch (err: any) {
            setError(err.message || 'Error creating CourseStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const edit = async (id: string, data: CourseStatusDTO) => {
        setIsLoading(true);
        try {
            await apiClient.updateCourseStatus(id, data);
        } catch (err: any) {
            setError(err.message || 'Error updating CourseStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const getById = async (id: string) => {
        setIsLoading(true);
        try {
            return await apiClient.getCourseStatusById(id);
        } catch (err: any) {
            setError(err.message || 'Error fetching CourseStatus');
        } finally {
            setIsLoading(false);
        }
    };

    const search = async (filters: any) => {
        setIsLoading(true);
        try {
            return await apiClient.searchCourseStatuses(filters);
        } catch (err: any) {
            setError(err.message || 'Error searching CourseStatuses');
        } finally {
            setIsLoading(false);
        }
    };

    const remove = async (id: string) => {
        setIsLoading(true);
        try {
            await apiClient.deleteCourseStatus(id);
        } catch (err: any) {
            setError(err.message || 'Error deleting CourseStatus');
        } finally {
            setIsLoading(false);
        }
    };

    return { create, edit, getById, search, remove, isLoading, error };
};